// Return true if window + document

'use strict';

module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-images/lib/utils/canUseDom.js
 ** module id = 1363
 ** module chunks = 0
 **/